/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useDispatch } from 'react-redux';
import Slider from 'react-slider';
import { setRange } from '../../store/features/branchSlice';
import './app.css';

function MultiRangeSlider({ range, min, max }) {
    const dispatch = useDispatch();
    const handleChange = (newValues) => {
        dispatch(setRange(newValues));
    };

    return (
        <div>
            <Slider
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={range}
                onAfterChange={handleChange}
                min={min}
                max={max}
            />
        </div>
    );
}

export default MultiRangeSlider;
